import React from 'react'
import { ForumPost } from '../../store/member/memberTypings'
import { useTranslation } from 'react-i18next'
import cls from './forumBlock.module.sass'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import paths from '../../paths'
import ButtonLink from '../ui/buttonLink'
import ForumLinks from './ForumLinks'

interface Props {
    forumPosts: ForumPost[]
    userForumPostsTotal: number
    self?: boolean
    userNick?: string
}

const ForumBlock = ({ forumPosts, self = false, userNick = '', userForumPostsTotal }: Props) => {
    const [t] = useTranslation()

    return (
        <div>
            <p className={cls['title']}>
                {self ? t('My participations in the forum') : t('Participations in the forum')}
            </p>
            <ForumLinks forumPosts={forumPosts} userForumPostsTotal={userForumPostsTotal} />
            <ButtonLink
                secondary
                label={self ? t('My participations in the forum') : t('Participations in the forum')}
                linkUrl={
                    self
                        ? createLocalizedPath(paths.myPosts.path) + '?p=1'
                        : createLocalizedPath(paths.profilePosts.toPath({ nick: userNick })) + '?p=1'
                }
            />
        </div>
    )
}

export default ForumBlock
